// const cloneParseStringify = obj => JSON.parse(JSON.stringify(obj));

// const cloneObject = obj => {
//   const copy = {};
//   for (const i in obj) {
//     if (obj[i] != null && typeof obj[i] === 'object') {
//       copy[i] = cloneObject(obj[i]);
//     } else {
//       copy[i] = obj[i];
//     }
//   }
//   return copy;
// };

// export const clone = obj => cloneParseStringify(obj);

declare var require;
export const clone = require('rfdc')();

export const isEmpty = (value: any) => value == null || value === '';
/**
 * @description To be use as a filter to get unique array values
 * @example
 *
 * arr.filter(getUnique);
 */
export const getUnique = (value, index, self) => self.indexOf(value) === index;

export const flat = (data: any[]): any[] => {
  return Array.isArray(data) ? data.reduce((r, e) => (Array.isArray(e) ? (r = r.concat(flat(e))) : r.push(e) && r), []) : data;
};

export const flatMap = (array: any[], mapFn: (value: any, index: number, array: any[]) => any[]): any[] => {
  return Array.prototype.concat(...array.map(mapFn));
};

export const createObservationsArray = (numberObservations: number): number[] => {
  const smallStep = 6;
  const bigStep = 12;
  const smallStepItems = 10;

  let numberArrayItems = 0;

  if (numberObservations > smallStepItems * smallStep) {
    numberArrayItems = Math.ceil(smallStepItems + (numberObservations - smallStepItems * smallStep) / bigStep);
  } else {
    numberArrayItems = Math.ceil(numberObservations / smallStep);
  }

  return new Array(numberArrayItems)
    .fill(null)
    .map((e, i) => (i < smallStepItems ? (i + 1) * smallStep : (i + 1) * bigStep - smallStepItems * smallStep))
    .filter(x => x < numberObservations)
    .concat(numberObservations);
};

/**
 * Returns the index of the **first** non-null element in an array.
 */
export const findFirstNonEmptyIndex = (arr: any[]): number => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] !== null) {
      return i;
    }
  }
  return null;
};

/**
 * Returns the index of the **last** non-null element in an array.
 */
export const findLastNonEmptyIndex = (arr: any[]): number => {
  return findFirstNonEmptyIndex(clone(arr).reverse());
};

export const caseInsensitiveIncludes = (a: string, b: string): boolean => {
  return a && b && a.toLocaleUpperCase().includes(b.toLocaleUpperCase());
};

export const caseInsensitiveReplace = (source: string, oldValue: string, newValue: string): string => {
  return oldValue && newValue && source.replace(oldValue.toLocaleLowerCase(), newValue).replace(oldValue.toLocaleUpperCase(), newValue);
};

export const parseLoadedDateTimeToJSON = (dateTimeStr: string) => {
  if (typeof dateTimeStr !== 'string') {
    return null;
  }

  const withZ = !dateTimeStr.endsWith('Z') ? `${dateTimeStr}Z` : dateTimeStr;
  return new Date(withZ).toJSON();
};

export const toPascal = (o: any) => {
  let newO;
  let origKey;
  let newKey;
  let value;

  if (o instanceof Array) {
    // tslint:disable-next-line:no-shadowed-variable
    return o.map(value => {
      if (typeof value === 'object') {
        value = toPascal(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString();
        value = o[origKey];
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
};
